export default {"src":"/_next/static/media/close.90b9b246.svg","height":10,"width":10,"blurWidth":0,"blurHeight":0};